$(function () {

    DECIX.dom.$navigationPrimary.find(".level-1 > li > .flyout").each(function (index, elem) {

        var $this = $(this);

        function navigationDoNavigate() {

            // Show 2nd-level items for current nav item
            $this.slideDown();

            // Hide other visible 2nd-level items from other nav items
            DECIX.dom.$navigationPrimary.find(".level-1 > li > .flyout").not($this).slideUp(0, function () {

                $(this).prev("a").removeClass("flyout-visible");

                // Move current nav item to top of viewport
                $("html,body").animate({
                    scrollTop: $this.parent().offset().top - 10
                }, 0);

            });

            $this.prev("a").addClass("flyout-visible");

        }

        // Clicking on the main menu items...
        $(elem).prev("a").on("click", function (event) {

            // ... expands the sub menu items...
            if (!$this.is(":visible")) {

                event.preventDefault();
                event.stopPropagation();

                navigationDoNavigate();

            }

            // ... otherwise we navigate to the link target.

        });

    });

    /*
     * Mobile menu toogle/trigger
     */
    DECIX.dom.$navigationPrimary.on("click", "#button-menu", function (event) {

        event.preventDefault();
        event.stopPropagation();

        var $this = $(this);

        $this.toggleClass("active");

        $this.next().toggleClass("mobile-menu-visible");

        DECIX.dom.$body.toggleClass("mobile-menu-visible");

    });

    /*
     * Tertiary navigation for event pages
     */
    DECIX.dom.$navigationTertiary.on("click", "#navigation-tertiary-toggle", function (event) {

        event.preventDefault();

        DECIX.dom.$navigationTertiary.find("#event-navigation").toggle();
        DECIX.dom.$navigationTertiary.find("#navigation-tertiary-toggle i").toggleClass("fa-chevron-up").toggleClass("fa-chevron-down");

    });

    /*
     * Make the secondary navigation buttons in mobile views behave like links
     */
    DECIX.dom.$navigationSecondary.on("click", "button[id^='button-']", function (event) {

        event.preventDefault();

        var url = $(this).data("link");

        location.replace(url);

    });

    /*
     * Function to reset the navigation
     */
    DECIX.functions.resetNavigation = function () {

        // Mobile menu
        DECIX.dom.$navigationPrimary.find("button").removeClass("active");
        DECIX.dom.$navigationPrimary.find("ul").removeClass("mobile-menu-visible");
        DECIX.dom.$body.removeClass("mobile-menu-visible");

        DECIX.dom.$navigationPrimary.find(".level-3").removeAttr("style");
        DECIX.dom.$navigationPrimary.find(".flyout").removeAttr("style");

        if ($(window).width() >= 992) {

            DECIX.dom.$navigationTertiary.find("#event-navigation").show();

        } else {

            DECIX.dom.$navigationTertiary.find("#event-navigation").hide();
            DECIX.dom.$navigationTertiary.find("#navigation-tertiary-toggle i")
                .removeClass("fa-chevron-up")
                .addClass("fa-chevron-down");

        }
    };

    /*
     * Reset menu on resize/orientation change
     * Closes all opened menus, flyouts and sublevel
     */
    $(window).on("orientationchange", function () {

        DECIX.functions.resetNavigation();

    });

});
